import { render, staticRenderFns } from "./BdTableIOS.vue?vue&type=template&id=9aaac6e4&scoped=true&"
import script from "./BdTableIOS.vue?vue&type=script&lang=js&"
export * from "./BdTableIOS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aaac6e4",
  null
  
)

export default component.exports